import { Svg } from "../../ws10";

const links = [
  {
    icon: Svg.Payg,
    quicklinksHeading: "Pay monthly",
    url: "/",
    onClickHandler: () => history.push("/")
  },
  {
    icon: Svg.Sim,
    quicklinksHeading: "SIM only deals",
    url: "/",
    onClickHandler: () => history.push("/")
  },
  {
    icon: Svg.Broadband,
    quicklinksHeading: "Broadband",
    url: "/broadband",
    onClickHandler: () => history.push("/")
  },
  {
    icon: Svg.Users,
    quicklinksHeading: "Manage account",
    url: "/"
  },
  {
    icon: Svg.Vodafone,
    quicklinksHeading: "Shop",
    url: "/shop"
  },
  {
    icon: Svg.Help,
    quicklinksHeading: "Support",
    url: "/"
  }
];

export default links;
